import { useSelector } from 'react-redux'

import type { Model } from '../../types'
import { getCurrentUserSelector } from '../slices/authentication-slice'

const useCurrentUser = () => {
  const currentUser = useSelector(getCurrentUserSelector) as Model.CurrentUser

  return currentUser
}

export default useCurrentUser
